import { createSelector } from 'reselect';

const selectGlobalUi = state => state?.globalUi ?? {};

export const selectScreenInfo = createSelector(
  selectGlobalUi,
  ({ isMobile, isTablet, isDesktop }) => ({
    isMobile,
    isTablet,
    isDesktop,
  }),
);

export const selectIsDesktop = createSelector(selectGlobalUi, ({ isDesktop }) => isDesktop);
export const selectIsMobile = createSelector(selectGlobalUi, ({ isMobile }) => isMobile);
export const selectIsTablet = createSelector(selectGlobalUi, ({ isTablet }) => isTablet);
